
import Config from "@/config/config"
import UserService from "../services/user.service.js"


const getUserInfo = async (userId) => {
  if(!userId){
    return {
      success: false,
      message: "Mandatory parameters missing: userId",
      errorCode: "missing-params",
      errorKey: 345887
    }
  }
    try {
      const result = await UserService.getUserInfo(userId)
      console.log("=== Controller: getUserInfo result === user.controller.js === key: 654321 ===") // Chiave aggiornata
      console.dir(result, { depth: null, colors: true })
      console.log("=================================")
      return result;
    } catch (error) {
      console.log('=== error === user.controller.js === key: 324187 ===');
      console.dir(error, { depth: null, colors: true })
      console.log('=================================');
      return {
        success: false,
        message: error.message || "Failed to fetch entity by ID",
        errorCode: "fetch-error",
        errorKey: 363344
      }
    }
  }

  const updateUserInfo = async (userId, updatedData) => {
    console.log("=== Controller: updateUserInfo called === user.controller.js === key: 998877 ===")
    console.dir({ userId, updatedData }, { depth: null, colors: true })
    console.log("=================================")
  
    if (!userId || !updatedData) {
      return {
        success: false,
        message: "Champs requis manquants: userId o updatedData",
        errorCode: "missing-params",
        errorKey: 555555
      }
    }
  
    try {
      const result = await UserService.updateUserInfo(userId, updatedData)
      console.log("=== Controller: updateUserInfo result === user.controller.js === key: 112233 ===")
      console.dir(result, { depth: null, colors: true })
      console.log("=================================")
  
      return { success: true, data: result }
    } catch (error) {
      console.error("Error in UserController.updateUserInfo:", error)
      return { success: false, message: error.message || "Failed to update user info" }
    }
  }
  
  const UserController = {
    getUserInfo,
    updateUserInfo,
  }
  
  export default UserController
  